import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Image,
  Input,
  List,
  Modal,
  Progress,
  Radio,
  Row,
  Select,
  Space,
  Switch,
  TimePicker,
  Upload,
  message,
} from 'antd';
import moment from 'moment';
import { LuUpload } from 'react-icons/lu';
import { FaLock } from 'react-icons/fa';
import Cookies from 'js-cookie';
import axios from '../../backendService';
import SubmitProgress from './SubmitProgress';
import ExistingVideosModal from '../video-modals/ExistingVideosModal';

const emptyVideoObj = {
  _id: '',
  videoURL: '',
  streamingURL: '',
  playbackURL: '',
  thumbnailURL: '',
  isLive: '',
  isSession: '',
  roomKey: '',
  title: '',
  description: '',
  teacher: '',
  course: '',
  subject: '',
  chapter: '',
  topic: '',
  videoQuestions: '',
  videoPolls: '',
  publishDate: '',
  startTime: '',
  endTime: '',
  isLatest: '',
  rating: '',
  createdAt: '',
  updatedAt: '',
  __v: '',
};

const RescheduleLectureForm = ({  courseLoading, userVideos }) => {
  const [form] = Form.useForm();

  const [personalFile, setPersonalFile] = useState(null);
  const [personalFileName, setPersonalFileName] = useState('');

  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [showUploadBar, setShowUploadBar] = useState(false);

  const [loading, setLoading] = useState(false);

  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [personalVideoURL, setPersonalVideoURL] = useState(null);
  const [personalThumbnailURL, setPersonalThumbnailURL] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(emptyVideoObj);

  // const [subjectList, setSubjectData] = useState([]);
  // const [chapterList, setChapterData] = useState([]);
  // const [topicList, setTopicData] = useState([]);

  // const [courseId, setCourseId] = useState('');
  // const [subjectId, setSubjectId] = useState('');
  // const [chapterId, setChapterId] = useState('');
  // const [topicId, setTopicId] = useState('');
  // const [filteredBatches, setFilteredBatches] = useState([]);
  const [batchesArr, setBatchesArr] = useState([]);

  const userId = Cookies.get('userId');

  // States for API data
  const [courseData, setCourseData] = useState([]);
  const [batchData, setBatchData] = useState([]);
  const [subjectData, setSubjectData] = useState([]);
  const [chapterData, setChapterData] = useState([]);
  const [topicData, setTopicData] = useState([]);

  // States for selected values
  const [courseId, setCourseId] = useState('');
  const [subjectId, setSubjectId] = useState('');
  const [chapterId, setChapterId] = useState('');
  // const [selectedbatch, setSelectedBatch] = useState('');
  const [topicId, setTopicId] = useState('');

  const [isBatchDisabled, setIsBatchDisabled] = useState(true);
  const [isSubjectDisabled, setIsSubjectDisabled] = useState(true);
  const [isChapterDisabled, setIsChapterDisabled] = useState(true);
  const [isTopicDisabled, setIsTopicDisabled] = useState(true);

    // === Fetch Courses (Initial Load) ===
    const fetchCourses = async () => {
      try {
        const response = await axios.post('/batch/getByTeacher', { teacherId: userId });
        // console.log('response--------', response);
        if (response.data.success) {
          message.success('Courses loaded successfully');
          setCourseData(response.data.data);
        } else {
          message.error(response.data.message || 'Failed to load courses.');
        }
      } catch (error) {
        console.error('Error fetching courses:', error);
        message.error('Error fetching courses. Please try again.');
      }
    };
  
    // === Fetch Batches ===
    const fetchBatches = async (courseId) => {
      try {
        const response = await axios.post('/batch/getFilteredBatches', { teacherId: userId, courseId });
        if (response.data.success) {
          // console.log('----------------------', response.data.data);
          message.success('Batch loaded successfully');
  
          setBatchData(response.data.data);
          setIsBatchDisabled(false);
        } else {
          setBatchData([]);
          setIsBatchDisabled(true);
          message.error(response.data.message || 'No batches found for the selected course.');
        }
      } catch (error) {
        console.error('Error fetching batches:', error);
        message.error('Error fetching batches. Please try again.');
      }
    };
  
    // === Fetch Subjects ===
    const fetchSubjects = async (courseId) => {
      try {
        const response = await axios.post('/courses/getMatchedSubjects', { courseId, teacherId: userId });
        if (response.data.success) {
          message.success('Subjects loaded successfully');
  
          setSubjectData(response.data.data);
          setIsSubjectDisabled(false);
        } else {
          setSubjectData([]);
          setIsSubjectDisabled(true);
          message.error(response.data.message || 'No subjects found for the selected course.');
        }
      } catch (error) {
        console.error('Error fetching subjects:', error);
        message.error('Error fetching subjects. Please try again.');
      }
    };
  
    // === Fetch Chapters ===
    const fetchChapters = async (subjectId) => {
      try {
        const response = await axios.post('/chapters/getChaptersBySubject', { subjectId });
        if (response.data.success) {
          message.success('Chapters loaded successfully');
  
          setChapterData(response.data.data);
          setIsChapterDisabled(false);
        } else {
          setChapterData([]);
          setIsChapterDisabled(true);
          message.error(response.data.message || 'No chapters found for the selected subject.');
        }
      } catch (error) {
        console.error('Error fetching chapters:', error);
        message.error('Error fetching chapters. Please try again.');
      }
    };
  
    // === Fetch Topics ===
    const fetchTopics = async (chapterId) => {
      try {
        const response = await axios.post('/chapters/getTopicsByChapter', { chapterId });
        if (response.data.success) {
          message.success('Topics loaded successfully');
  
          setTopicData(response.data.data);
          setIsTopicDisabled(false);
        } else {
          setTopicData([]);
          setIsTopicDisabled(true);
          message.error(response.data.message || 'No topics found for the selected chapter.');
        }
      } catch (error) {
        console.error('Error fetching topics:', error);
        message.error('Error fetching topics. Please try again.');
      }
    };

    useEffect(() => {
      fetchCourses();
      // form.resetFields();
    }, []);
  // console.log("courseData",courseData)
  const clearPersonalUploadedFile = () => {
    form.setFieldValue('newVideoFile', null);
    // setCourseId('');
    setCourseId('')
    setPersonalFileName('');
    setPersonalFile(null);
    setPersonalVideoURL(null);
    form.resetFields();
    setSelectedVideo(emptyVideoObj);
    setBatchesArr([]);
  };


  // useEffect(() => {
  //   setSubjectData([]);
  //   setChapterData([]);
  //   setTopicData([]);
  //   form ? form.setFieldValue('batches', []) : null;
  //   form ? form.setFieldValue('subjectName', null) : null;
  //   form ? form.setFieldValue('chapterName', null) : null;
  //   form ? form.setFieldValue('topicName', null) : null;

  //   const filteredCourseData = courseData.filter((course) => {
  //     return course._id === courseId;
  //   });

  //   filteredCourseData.map((course) => {
  //     let subjectObjects = [];
  //     course.subjects.map((subject) => {
  //       subjectObjects.push(subject);
  //     });
  //     setSubjectData(subjectObjects);
  //   });

  //   setFilteredBatches(batchData.filter((batch) => batch.course._id === courseId));
  // }, [courseId]);

  // useEffect(() => {
  //   setChapterData([]);
  //   setTopicData([]);
  //   form ? form.setFieldValue('chapterName', null) : null;
  //   form ? form.setFieldValue('topicName', null) : null;
  //   const filteredSubjectData = subjectList.filter((subject) => {
  //     return subject._id === subjectId;
  //   });

  //   let chapterObjects = [];
  //   if (filteredSubjectData.length) {
  //     filteredSubjectData[0].chapters.map((chapter) => {
  //       chapterObjects.push(chapter);
  //     });
  //     setChapterData(chapterObjects);
  //   }
  // }, [subjectId]);

  // useEffect(() => {
  //   setTopicData([]);
  //   form ? form.setFieldValue('topicName', null) : null;

  //   const filteredchapterData = chapterList.filter((chapter) => {
  //     return chapter._id === chapterId;
  //   });

  //   let topicObjects = [];
  //   if (filteredchapterData.length) {
  //     filteredchapterData[0].topics.map((topic) => {
  //       topicObjects.push(topic);
  //     });
  //     setTopicData(topicObjects);
  //   }

  //   // if (chapterId) {
  //   //   fetchTopics(chapterId);
  //   // }
  // }, [chapterId]);

    // === useEffect: Fetch Batches and Subjects when Course changes ===
    useEffect(() => {
      if (courseId) {
        fetchBatches(courseId);
        fetchSubjects(courseId);
  
        // Reset downstream dependencies
        setBatchData([]);
        setSubjectData([]);
        setChapterData([]);
        setTopicData([]);
        setIsBatchDisabled(true);
        setIsSubjectDisabled(true);
        setIsChapterDisabled(true);
        setIsTopicDisabled(true);
      }
    }, [courseId]);
  
    // === useEffect: Fetch Chapters when Subject changes ===
    useEffect(() => {
      if (subjectId) {
        fetchChapters(subjectId);
  
        // Reset downstream dependencies
        setChapterData([]);
        setTopicData([]);
        setIsChapterDisabled(true);
        setIsTopicDisabled(true);
      }
    }, [subjectId]);
  
    // === useEffect: Fetch Topics when Chapter changes ===
    useEffect(() => {
      if (chapterId) {
        fetchTopics(chapterId);
  
        // Reset downstream dependencies
        setTopicData([]);
        setIsTopicDisabled(true);
      }
    }, [chapterId]);
  useEffect(() => {
    const extractedVideo = userVideos.find((video) => video.videoURL === personalVideoURL);
    if (extractedVideo) setSelectedVideo(extractedVideo);
  }, [personalVideoURL]);

  useEffect(() => {
    if (selectedVideo && selectedVideo.videoURL !== '') {
      form.setFieldValue('title', selectedVideo.title);
      form.setFieldValue('description', selectedVideo.description);
      form.setFieldValue('courseName', selectedVideo.course.courseName);
      form.setFieldValue(
        'batches',
        selectedVideo.batches.map((item) => item.name),
      );
      form.setFieldValue('subjectName', selectedVideo.subject.subjectName);
      form.setFieldValue('chapterName', selectedVideo.chapter.chapterName);
      form.setFieldValue('topicName', selectedVideo.topic.topicName);
      setBatchesArr(selectedVideo.batches.map((item) => item._id));
    }
  }, [selectedVideo]);

  const handlePersonalRescheduleFormSubmit = async (values) => {
    setLoading(true);
    // console.log('values', values);
    const params = new URLSearchParams();

    params.append('title', values.title);
    params.append('description', values.description);
    params.append('course', courseId);
    params.append('subject', subjectId);
    params.append('chapter', chapterId);
    params.append('topic', topicId);
    params.append('teacher', userId);
    params.append('videoURL', personalVideoURL);
    params.append('thumbnailURL', personalThumbnailURL);

    let data = {
      videoURL: personalVideoURL,
      thumbnailURL: personalThumbnailURL,
      title: values.title,
      description: values.description,
      course: courseId !== '' ? courseId : selectedVideo.course._id,
      batches: batchesArr,
      subject: subjectId !== '' ? subjectId : selectedVideo.subject._id,
      chapter: chapterId !== '' ? chapterId : selectedVideo.chapter._id,
      topic: topicId !== '' ? topicId : selectedVideo.topic._id,
      teacher: userId,
    };

    const date = form.getFieldValue('publishDate').format('YYYY-MM-DD');
    const formattedStartTime = form.getFieldValue('startTime').format('HH:mm');
    const formattedEndTime = form.getFieldValue('endTime').format('HH:mm');
    data = { ...data, publishDate: date, startTime: formattedStartTime, endTime: formattedEndTime };
    params.append('publishDate', date);
    params.append('startTime', formattedStartTime);
    params.append('endTime', formattedEndTime);

    try {
      // console.log('submitted data', data);
      const res = await axios.post('/videos/rescheduleVideo', data, {
        headers: {
          'Content-Type': 'application/json',
        },
        onUploadProgress: (p) => {
          setShowUploadBar(true);
          const percentageCompleted = Math.round((p.loaded * 100) / p.total);
          setUploadPercentage(percentageCompleted);
        },
      });
      setLoading(false);
      setShowUploadBar(false);
      clearPersonalUploadedFile();
      setSelectedVideo(emptyVideoObj);
      setBatchesArr([]);
      form.resetFields();
      message.success('Lecture uploaded and scheduled for streaming');
    } catch (err) {
      console.error('Error:', err.response ? err.response.data : err.message);
      setLoading(false);
      setUploadPercentage(0);
      setShowUploadBar(false);
      message.error('Something went wrong, check if all fields are correct');
    }
  };

  const handleBatchSelect = (selectedId) => {
    // setBatchId(selectedId)
    form.setFieldValue({ batches: selectedId });
    setBatchesArr(selectedId);
  };

  const openSelectVideoModal = () => {
    setOpenVideoModal(true);
    // setCourseId('');
    setCourseId('')
    setSelectedVideo(emptyVideoObj);
    form.resetFields();
    form.setFieldValue('newVideoFile', null);
    setPersonalFileName('');
    setPersonalFile(null);
    setPersonalVideoURL(null);
  };

  return (
    <>
      <Form layout={'vertical'} form={form} onFinish={handlePersonalRescheduleFormSubmit}>
        <Space size={'large'} style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }} wrap>
          <Form.Item
            getValueFromEvent={personalVideoURL !== null}
            size={'large'}
            // rules={[{ required: personalVideoURL === null ? true : false, message: 'This field is required' }]}
            rules={[{ required: false, message: 'This field is required' }]}
          >
            <Button
              onClick={openSelectVideoModal}
              style={{ width: '100%' }}
              size="large"
              type="primary"
              icon={<LuUpload />}
              className="text-sm text-blue-700 gap-2 flex items-center justify-start"
            >
              Select lecture
            </Button>
          </Form.Item>
          <Form.Item
            name="personalFileName"
            rules={[{ required: personalFileName !== '' ? false : true, message: 'Please select a lecture!' }]}
          >
            <Input size={'small'} disabled placeholder={personalFileName} value={personalFileName} />
          </Form.Item>
          {personalFileName !== '' && (
            <Form.Item size={'large'}>
              <Space style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }} wrap>
                {personalFileName !== '' && (
                  <Button
                    onClick={clearPersonalUploadedFile}
                    type="default"
                    size="small"
                    className="bg-red-500 text-white ml-2"
                  >
                    Delete
                  </Button>
                )}
              </Space>
            </Form.Item>
          )}
        </Space>
        <Form.Item name="title" rules={[{ required: true, message: 'Please enter video title!' }]}>
          <Input placeholder="Enter video title" />
        </Form.Item>
        <Form.Item
          name="description"
          placeholder="Enter video description"
          rules={[{ required: true, message: 'Please enter video description!' }]}
        >
          <Input.TextArea placeholder="Enter video description" />
        </Form.Item>
        {/* <Form.Item size={'large'} name="courseName" rules={[{ required: true, message: 'Please select a course!' }]}>
          <Select placeholder="Select course" onChange={(e) => setCourseId(e)}>
            {courseLoading && courseData.length === 0 ? (
              <Select.Option value={null}>Loading courses .....</Select.Option>
            ) : courseData.length === 0 ? (
              <Select.Option value={null}>No courses assigned.</Select.Option>
            ) : (
              courseData.map((course) => (
                <Select.Option key={course.courseName} value={course._id}>
                  {course.courseName}
                </Select.Option>
              ))
            )}
          </Select>
        </Form.Item>
        <Form.Item size={'large'} name="batches" rules={[{ required: true, message: 'Please select a batch!' }]}>
          <Select
            disabled={filteredBatches.length === 0}
            placeholder="Select batch"
            onChange={handleBatchSelect}
            mode="multiple"
          >
            {courseLoading && filteredBatches.length === 0 ? (
              <Select.Option value={null}>Loading batches .....</Select.Option>
            ) : filteredBatches.length === 0 ? (
              <Select.Option value={null}>No courses assigned.</Select.Option>
            ) : (
              filteredBatches.map((batch) => (
                <Select.Option key={batch._id} value={batch._id}>
                  {batch.name}
                </Select.Option>
              ))
            )}
          </Select>
        </Form.Item>
        <Form.Item size={'large'} name="subjectName" rules={[{ required: true, message: 'Please select a subject!' }]}>
          <Select disabled={subjectList.length === 0} placeholder="Select subject" onChange={(e) => setSubjectId(e)}>
            {subjectList.map((subject) => (
              <Select.Option key={subject.subjectName} value={subject._id}>
                {subject.subjectName}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          size={'large'}
          placeholder="Select Chapter"
          name="chapterName"
          rules={[{ required: true, message: 'Please select a chapter!' }]}
        >
          <Select disabled={chapterList.length === 0} onChange={(e) => setChapterId(e)} placeholder="Select chapter">
            {chapterList.map((chapter) => (
              <Select.Option key={chapter.chapterName} value={chapter._id}>
                {chapter.chapterName}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item size={'large'} name="topicName" rules={[{ required: true, message: 'Please select a topic!' }]}>
          <Select onChange={(e) => setTopicId(e)} disabled={topicList.length === 0} placeholder="Select Topic">
            {topicList.map((topic) => (
              <Select.Option key={topic.topicName} value={topic._id}>
                {topic.topicName}
              </Select.Option>
            ))}
          </Select>
        </Form.Item> */}
         <Form.Item label="Select Course" name="courseName" rules={[{ required: true, message: 'Please select a course!' }]}>
          <Select
            placeholder="Select a course"
            onChange={(value) => {
              setCourseId(value);
              form.resetFields(['batches', 'subjectName', 'chapterName', 'topicName']);
            }}
          >
            {courseData.map((course) => (
              <Select.Option key={course.courseId} value={course.courseId}>
                {course.courseName}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {/* Batch Selection */}
        <Form.Item label="Select Batches" name="batches" rules={[{ required: true, message: 'Please select a batch!' }]}>
          <Select
            mode="multiple"
            placeholder="Select batches"
            onChange={(value) => {
              setBatchesArr(value);
              form.resetFields(['subjectName', 'chapterName', 'topicName']);
            }}
            disabled={isBatchDisabled}
          >
            {batchData.map((batch) => (
              <Select.Option key={batch.batchId} value={batch.batchId}>
                {batch.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {/* Subject Selection */}
        <Form.Item label="Select Subject" name="subjectName" rules={[{ required: true, message: 'Please select a subject!' }]}>
          <Select
            placeholder="Select a subject"
            onChange={(value) => {
              setSubjectId(value);
              form.resetFields(['chapterName', 'topicName']);
            }}
            disabled={isSubjectDisabled}
          >
            {subjectData.map((subject) => (
              <Select.Option key={subject.subjectId} value={subject.subjectId}>
                {subject.subjectName}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        {/* Chapter Selection */}
        <Form.Item label="Select Chapter" name="chapterName" rules={[{ required: true, message: 'Please select a chapter!' }]}>
          <Select
            placeholder="Select a chapter"
            onChange={(value) => {
              setChapterId(value);
              form.resetFields(['topicName']);
            }}
            disabled={isChapterDisabled}
          >
            {chapterData.map((chapter) => (
              <Select.Option key={chapter.chapterId} value={chapter.chapterId}>
                {chapter.chapterName}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        {/* Topic Selection */}
        <Form.Item label="Select Topic" name="topicName" rules={[{ required: true, message: 'Please select a topic!' }]}>
          <Select
            placeholder="Select a topic"
            onChange={(value) => {
              setTopicId(value);
              // form.resetFields(['topicName']);
            }}
            disabled={isTopicDisabled}
          >
            {topicData.map((topic) => (
              <Select.Option key={topic.topicId} value={topic.topicId}>
                {topic.topicName}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Space style={{ display: 'flex', justifyContent: 'start' }} size={'large'} wrap>
          <Form.Item
            size={'large'}
            name="publishDate"
            label="Lecture schedule date"
            rules={[{ required: true, message: 'Please select a date!' }]}
          >
            <DatePicker
              style={{ width: '100%' }}
              placeholder="Select schedule date"
              disabledDate={(current) => {
                return current && current < moment().startOf('day');
              }}
            />
          </Form.Item>
          <Form.Item
            size={'large'}
            name="startTime"
            label="Lecture start time"
            rules={[{ required: true, message: 'Please select a start time!' }]}
          >
            <TimePicker placeholder="Lecture start time" format={'HH:mm'} />
          </Form.Item>
          <Form.Item
            size={'large'}
            name="endTime"
            label="Lecture end time"
            rules={[{ required: true, message: 'Please select a end time!' }]}
          >
            <TimePicker placeholder="Lecture end time" format={'HH:mm'} />
          </Form.Item>
        </Space>
        <Form.Item>
          <Button size="large" type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form.Item>
      </Form>
      {showUploadBar && <Progress percent={uploadPercentage} className=" z-99998" />}
      <ExistingVideosModal
        courseData={courseData}
        userVideos={userVideos}
        isOpen={openVideoModal}
        setOpenVideoModal={setOpenVideoModal}
        setPersonalVideoURL={setPersonalVideoURL}
        setPersonalThumbnailURL={setPersonalThumbnailURL}
        setPersonalFileName={setPersonalFileName}
      />
    </>
  );
};

export default RescheduleLectureForm;
